import { PWA_INSTALL_DISMISSAL_STORAGE_KEY } from "@/lib/pwaInstallStorage";

export function readPwaInstallDismissedUntil(storage?: Pick<Storage, "getItem">): number {
  try {
    const target = storage ?? (typeof window === "undefined" ? null : window.localStorage);
    if (!target) return 0;

    const value = Number(target.getItem(PWA_INSTALL_DISMISSAL_STORAGE_KEY));
    return Number.isFinite(value) && value > 0 ? value : 0;
  } catch {
    return 0;
  }
}
